'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colors = require('../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  root: {
    maxWidth: '256px',
    width: '100%'
  },
  inputRoot: {
    height: '32px'
  },
  input: {
    appearance: 'none',
    backgroundColor: _colors2.default.inputs,
    border: '0',
    borderRadius: '4px',
    height: '32px',
    boxSizing: 'border-box',
    color: _colors2.default.primaryText,
    fontSize: '16px',
    fontWeight: 'inherit',
    fontFamily: 'inherit',
    lineHeight: '16px',
    padding: '6.5px 8px',
    width: '100%',
    outline: 'none',
    ':focus': {
      outline: 'none'
    }
  },
  textarea: {
    resize: 'none',
    overflow: 'auto'
  },
  label: {
    fontSize: '16px',
    color: _colors2.default.secondaryText,
    fontWeight: 'bolder',
    boxSizing: 'border-box',
    display: 'block',
    paddingBottom: '8px',
    textTransform: 'capitalize',
    width: '100%'
  },
  disabled: {
    opacity: '0.5'
  },
  error: {
    display: 'block',
    paddingTop: '6px',
    paddingLeft: '8px',
    color: _colors2.default.error,
    fontSize: '14px'
  },
  placeholder: {
    color: _colors2.default.placeholderText
  }
};
module.exports = exports.default;